import { defineComponent as _defineComponent } from 'vue'
import * as validation from 'JS/components/blain-form/validation';
import Icon from 'JS/components/Icon.vue';
import TransitionExpand from 'JS/components/transitions/TransitionExpand.vue';
import { BTextField } from 'JS/components/blain-form';
import { computed, ref } from 'vue';
import { PasswordRequirements } from 'JS/types/Account';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePasswordField',
  props: {
    password: null
  },
  setup(__props: any) {

const props = __props as {
	password: string
}



const isPasswordFocused = ref(false);

const validatedPassword = computed<PasswordRequirements>(() => ({
	hasMinLength: props.password.length >= 8,
	hasUppercase: /[A-Z]/.test(props.password),
	hasLowercase: /[a-z]/.test(props.password),
	hasNumber: /[0-9]/.test(props.password)
}));

const ariaRequirementInfo = computed<string>(() => {
	let message = "";

	const { ...x } = validatedPassword.value;
	if (!x.hasLowercase) {
		message = message + "Password requires at least 1 lowercase character. ";
	}
	if (!x.hasUppercase) {
		message = message + "Password requires at least 1 uppercase character. ";
	}
	if (!x.hasMinLength) {
		message = message + "Password must be 8 characters long. ";
	}
	if (!x.hasNumber) {
		message = message + "Password requires at least 1 number. ";
	}
	if (!message.length) {
		message = "Password requirements met.";
	}

	return message;
});


return { __sfc: true,props, isPasswordFocused, validatedPassword, ariaRequirementInfo, validation, Icon, TransitionExpand, BTextField }
}

})